<div class="item">
  <button
    class="label"
    (click)="signatureDialog()"
    [disabled]="checkStatus() !== 'OPEN'"
  >
    <img class="icon" src="../../../../../../assets/icons/sign.png" alt="" />

    <span class="oa-title"
      >{{ action.action_name }}
      <img
        *ngIf="checkStatus() == 'OPEN'"
        src="../../../../../../../../assets/icons/{{
          'Tag_to_do.svg' | translate
        }}"
        alt=""
      />
    </span>
  </button>

  <div
    *ngIf="checkStatus() !== 'OPEN' && checkStatus() !== 'DONE'"
    class="actions"
  >
    <mat-icon
      class="info"
      [matTooltip]="
        checkStatus() === 'PENDING'
          ? infoPendingMessage
          : checkStatus() === 'DONE'
          ? action.description!
          : ''
      "
      >info</mat-icon
    >
  </div>
  <div *ngIf="checkStatus() == 'DONE'" class="actions">
    <mat-icon class="success">done</mat-icon>

    <button [matMenuTriggerFor]="menu" [disabled]="isLoading">
      <mat-icon *ngIf="!isLoading">more_vert</mat-icon>
      <mat-progress-spinner
        *ngIf="isLoading"
        diameter="24"
        mode="indeterminate"
        color="primary"
      ></mat-progress-spinner>
    </button>
    <mat-menu #menu="matMenu" class="menu" xPosition="before">
      <button mat-menu-item="" (click)="downloadDocument()">
        <span>{{ "DownloadDocument" | translate }}</span>
      </button>
      <button mat-menu-item="" (click)="retractSignature()">
        <span>{{ "RetractSignature" | translate }}</span>
      </button>
    </mat-menu>
  </div>
</div>
